import { render, staticRenderFns } from "./SkillsLevelsComparisonRecap.vue?vue&type=template&id=1ddf867d&scoped=true"
import script from "./SkillsLevelsComparisonRecap.vue?vue&type=script&lang=js"
export * from "./SkillsLevelsComparisonRecap.vue?vue&type=script&lang=js"
import style0 from "./SkillsLevelsComparisonRecap.vue?vue&type=style&index=0&id=1ddf867d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf867d",
  null
  
)

export default component.exports